import mediaQueries from 'syf-component-library/const/mediaQueries';
import useMedia from 'syf-js-utilities/hooks/useMedia';
const useDeviceWidth = ({ query = mediaQueries.lessThanMedium } = {}) => {
    return useMedia([query], [true], false);
};
export default useDeviceWidth;
//# sourceMappingURL=use-device-width.js.map